export default function LoadingSpinner({ size = 'md', style = {} }) {
  const px = size === 'sm' ? 40 : size === 'lg' ? 100 : 64;
  return (
    <img
      src="/assets/images/Castar_web_Loading_motion_black_v2.gif"
      alt="로딩 중"
      width={px}
      height={px}
      style={{ display: 'block', objectFit: 'contain', ...style }}
    />
  );
}
